'use strict';

var React = require('react');

var SvgManagedStoreMajor = function SvgManagedStoreMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.03 12.03a.75.75 0 1 0-1.06-1.06l-2.47 2.47-.97-.97a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06 0l3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.96 2.5h-7.92c-.448 0-.863.24-1.085.63l-1.79 3.133a1.25 1.25 0 0 0-.165.62v.867a2.75 2.75 0 0 0 1.5 2.45v5.55c0 .966.784 1.75 1.75 1.75h7.5a1.75 1.75 0 0 0 1.75-1.75v-5.55a2.75 2.75 0 0 0 1.5-2.45v-.867a1.25 1.25 0 0 0-.165-.62l-1.79-3.133a1.25 1.25 0 0 0-1.085-.63Zm-7.775 1.5h7.63l1.685 2.95v.8c0 .69-.56 1.25-1.25 1.25h-.25c-.69 0-1.25-.56-1.25-1.25v-.5a.75.75 0 0 0-1.5 0v.5a1.25 1.25 0 1 1-2.5 0v-.5a.75.75 0 0 0-1.5 0v.5c0 .69-.56 1.25-1.25 1.25h-.25c-.69 0-1.25-.56-1.25-1.25v-.8l1.685-2.95Zm5.815 5.637a2.742 2.742 0 0 0 2 .863v5.25a.25.25 0 0 1-.25.25h-7.5a.25.25 0 0 1-.25-.25v-5.25c.788 0 1.499-.331 2-.863a2.742 2.742 0 0 0 2 .863c.788 0 1.499-.331 2-.863Z"
  }));
};
SvgManagedStoreMajor.displayName = "ManagedStoreMajor";

exports.SvgManagedStoreMajor = SvgManagedStoreMajor;
